































































































import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import Multiply from "../resources/multiply.vue";
import ValueDown from "../resources/valueDown.vue";

const isElement = (x: any): x is HTMLInputElement =>
    x instanceof HTMLInputElement;

@Component({
  components: {
    ValueEdit,
    DropdownList,

    Multiply,
    ValueDown
  }
})
export default class TopController extends Vue {
    @Prop()
    private width!: number;
    @Prop()
    private height!: number;
    @Prop()
    private range!: number;
    @Prop()
    private paperDirection!: number;

    changeSearchProperty(value: any, propertyName: string) {
        this.$emit("changeSearchProperty", value, propertyName);
    }

    changeSearchType() {
        this.$emit("changeSearchType", "text");
    }

    reset(){
        this.changeSearchProperty(0 , "width")
        this.changeSearchProperty(0 , "height")
        this.changeSearchProperty(3 , "range")
        this.search()
    }

    search() {
        this.$emit("search");
    }

    //編集面の回転
    private isPaperDirectionDropdownActive = false;

    private get paperDirectionText() {
        var text = "";
        if (this.paperDirection == 0) {
            text = "回転しない";
        } else if (this.paperDirection == 1) {
            text = "90°回転";
        } else if (this.paperDirection == 2) {
            text = "180°回転";
        } else if (this.paperDirection == 3) {
            text = "270°回転";
        }
        return text;
    }

    private get paperDirectionDropdownItems() {
        var items = new Array();
        items.push({
            id: 0,
            label: "回転しない",
            isSelected: this.paperDirection == 0
        });
        items.push({
            id: 1,
            label: "90°回転",
            isSelected: this.paperDirection == 1
        });
        items.push({
            id: 2,
            label: "180°回転",
            isSelected: this.paperDirection == 2
        });
        items.push({
            id: 3,
            label: "270°回転",
            isSelected: this.paperDirection == 3
        });
        return items;
    }

    private onClickPaperDirection() {
        this.isPaperDirectionDropdownActive = true;
    }

    onSelectPaperDirection(paperDirection) {
        this.isPaperDirectionDropdownActive = false;
        this.paperDirection = paperDirection;
    }

    tabKeyDown(event, isShiftKeyDown){
        var movePoint = (isShiftKeyDown ? -1 : 1);
        var elements = (<HTMLElement>this.$refs["search-size-area"]).getElementsByClassName("input");
        var index = [].findIndex.call(elements, e => e === event.target);
        var moveIndex = index + movePoint;
        if(moveIndex >= elements.length || moveIndex <= 0){ return; }
        while((<HTMLElement>elements[moveIndex].firstElementChild).tagName != "P"){
            moveIndex += movePoint;
            if(moveIndex >= elements.length || moveIndex <= 0){ break; }
        }
        (<HTMLElement>elements[moveIndex].firstElementChild).click();
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineStyle(){
        var style = {
            background : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
    private get userConfigColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }
}
